/**
 * Cross-tab pending-files handoff.
 *
 * Founder direction (2026-07-26): laptop upload must match phone —
 * pick / drag ALL files first, THEN pick the purpose. The Files
 * themselves can't cross a react-router navigation via URL or
 * localStorage, so we stash them in a module-scoped variable and let
 * the ImportTodaysRecordings page pull them on mount.
 */

let pendingFiles = null;

export function stashPendingFiles(files) {
  pendingFiles = Array.isArray(files) ? files : Array.from(files || []);
}

export function takePendingFiles() {
  const out = pendingFiles;
  pendingFiles = null;
  return out;
}

export function peekPendingFilesCount() {
  return pendingFiles ? pendingFiles.length : 0;
}
